import { DateSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/dateSubtype";
import { BaseModuleSubtype } from "../../../../../../types/actionModule/subtypes/subtype";

interface Props {
    subtype: BaseModuleSubtype;
    subtypeData: DateSubtypeDataModel;
}

export default function DateSubtypeDetails(props: Props) {
    return (
        <>
            {props.subtypeData.selectedDate
                ? new Date(props.subtypeData.selectedDate).toLocaleDateString()
                : "-"}
        </>
    );
}